import { render, staticRenderFns } from "./simplifyOwnerComplaint.vue?vue&type=template&id=4b560bd7&scoped=true"
import script from "./simplifyOwnerComplaint.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerComplaint.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerComplaint.vue?vue&type=style&index=0&id=4b560bd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b560bd7",
  null
  
)

export default component.exports